import React, { useState } from 'react'
import styled from 'styled-components'
import { Flex } from 'ui/acro'
import { Button } from 'ui/bend'
import { axios } from 'api'
import ProgramCardLarge from '../components/ProgramCardLarge'
import MobileStickyModal from './MobileStickyModal'
import StopProgramModalContent from './StopProgramModalContent'
import { camelToSnake } from 'utils'

const MOBILE_LIMIT = 3

const Container = styled(Flex)({
  flexDirection: 'column'
})
const CardWrapper = styled('div')({
  transition: 'all 0.3s ease'
})

const ProgramsInProgressMobile = ({
  inProgressitems,
  selectedProgramSlug,
  setSelectedProgramSlug = () => {},
  fetchProgramData = () => {},
  totalInProgressitems,
  eventName,
  location
}) => {
  const [expanded, setExpanded] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const visibleItems = expanded
    ? inProgressitems
    : inProgressitems.slice(0, MOBILE_LIMIT)

  const stopProgram = async (slug) => {
    if (!slug) return
    setIsSubmitting(true)
    try {
      const res = await axios.post(`/programs/${slug}/stop`)
      if (res?.data?.ga4Event) {
        window.dataLayer ||= []
        window.dataLayer.push(camelToSnake(res.data?.ga4Event))
      }
      if (res) {
        fetchProgramData({ isRemove: true })
      }
    } catch (e) {
      console.log('e', e)
    } finally {
      setSelectedProgramSlug('')
      setIsSubmitting(false)
    }
  }

  const handleViewMore = () => {
    setExpanded(true)
    if (
      parseInt(totalInProgressitems) > inProgressitems.length &&
      visibleItems.length === inProgressitems.length
    ) {
      fetchProgramData()
    }

    if (parseInt(totalInProgressitems) === visibleItems.length) {
      setExpanded(false)
    }
  }

  return (
    <Container>
      {visibleItems.map((item) => (
        <CardWrapper key={item?.slug}>
          <ProgramCardLarge
            {...item}
            eventName={eventName}
            location={location}
          />
        </CardWrapper>
      ))}

      {parseInt(totalInProgressitems) > MOBILE_LIMIT && (
        <Button
          onClick={() => handleViewMore()}
          height='24px'
          width='100%'
          mt='24px'
          variant='ouline'
          style={{
            fontSize: '16px',
            fontWeight: 500,
            color: '#000',
            cursor: 'pointer'
          }}
        >
          {parseInt(totalInProgressitems) === visibleItems.length
            ? 'View Less'
            : 'Show All In Progress'}
        </Button>
      )}
      <MobileStickyModal
        open={Boolean(selectedProgramSlug)}
        onClose={() => setSelectedProgramSlug('')}
        title={'Stop Program'}
      >
        <StopProgramModalContent
          onSubmit={() => stopProgram(selectedProgramSlug)}
          onCancel={() => setSelectedProgramSlug('')}
          isSubmitting={isSubmitting}
        />
      </MobileStickyModal>
    </Container>
  )
}

export default ProgramsInProgressMobile
